var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{class:_vm.props.column.renderOptions ? _vm.props.column.renderOptions.class : null},[_vm._v(_vm._s(_vm.props.value))])}
var staticRenderFns = []

export { render, staticRenderFns }